<template>
  <div class="help">
    <no-cookies />
    <hr />
    <h1>WeShareToo FAQ:</h1>
    <h2>Hvorfor har jeg lavet WeShareToo</h2>
    <p>
      Jeg har brugt den originale WeShare længe, og har været utroligt glad for
      den. Jeg blev noget ærgerlig da MobilePay valgte at lukke servicen uden at
      have et godt alternativ på plads. Og så er det jo rimeligt simpelt bare
      selv at lave en.
    </p>
    <hr />
    <h2>Er det gratis?</h2>
    <p>
      Ja. Så længe det ikke koster mig noget særligt vil det forblive gratis.
      Men hvis samtlige 1,2 million WeShare brugere vælger at bruge denne
      løsning, vil mit nuværende opsætning ikke kunne følge med, og så må jeg
      enten begrænse adgangen, lukke det hele ned, eller flytte det hele til
      noget større & dyrere.
    </p>
    <hr />
    <h2>Hvorfor er der virtuelle brugere?</h2>
    <p>
      Det er for at man straks kan se hvordan fordelingen af udgifter vil blive.
      Det kan godt være de skal vises lidt anderledes fremover.<br /><br />Se en
      lidt længere beskrivelse under "hjælp".
    </p>
    <hr />
    <h2>Hvorfor er det ikke en app?</h2>
    <p>
      WeShareToo kan godt installeres som en app på både android og iOS.
      <b-img
        center
        fluid
        width="250vw"
        src="img\help\install-as-app\installed_as_app.png"
      />
      <br /><br />
      Fordelen er at den så ligger lige på startskærmen, men ulempen er den ikke
      altid lige opdaterer sig selv til den seneste version.<br /><br />Se
      "Installer som app" punktet under Hjælp.<br /><br />
    </p>
    <h2>Hvorfor skal jeg ikke acceptere cookies?</h2>
    <p>
      Fordi siden ikke bruger cookies, og jeg synes det er det mest irriterende
      i verden at skulle svare ja eller nej til.
    </p>
    <hr />
  </div>
</template>

<script>
import NoCookies from "@/components/general/noCookies.vue";

export default {
  name: "HelpView",
  components: { NoCookies },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style lang="css" scoped>
.myBut {
  font-family: monospace;
}
p,
div {
  margin: auto;
  font-family: "Special Elite", "IBM Plex Mono", monospace;
  font-size: medium;
  font-weight: bold;
  letter-spacing: 2px;
  text-align: justify;
  text-overflow: clip;
  padding: 2vh;
  max-width: 45em;
}
</style>
